import React from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';
import IdleLogoutModal from '../IdleLogoutModal';
import AttendanceReminderModal from '../AttendanceReminderModal';
import useStore from '../../store';
import './AppLayout.css';

export default function AppLayout() {
  const { sidebarCollapsed } = useStore();

  return (
    <div className={`app-layout ${sidebarCollapsed ? 'app-layout--collapsed' : ''}`}>
      <Sidebar />
      <div className="app-main">
        <Header />
        <main className="app-content">
          <Outlet />
        </main>
      </div>
      <IdleLogoutModal />
      <AttendanceReminderModal />
    </div>
  );
}
